;(() => {
  function groupSummary({ adults, childrenAges, i18n, locale }) {
    const resolvedLocale = locale || window.locale || "en"
    const adultsLabel = HB.pluralize(adults, i18n?.adults, resolvedLocale)
    const childrenLabel = childrenAges.length
      ? HB.pluralize(childrenAges.length, i18n?.children, resolvedLocale)
      : null
    const connector = i18n?.not_a_list_connector || ", "
    return [adultsLabel, childrenLabel].filter(Boolean).join(connector)
  }

  window.HB = window.HB || {}
  window.HB.groupSummary = groupSummary
})()
